import { atom, useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { QhpWithLocationInfo, useLiveLocations } from '../../fetching/api/liveLocations';
import { IClinicianOption } from '../clinicians/OptionalClinicianSelector';
import { GoogleMapStopsProp } from '../mapping/GoogleMap/GoogleMap';
import { GoogleMapWithAtom } from '../mapping/GoogleMap/GoogleMapWithAtom';

const stopsAtom = atom<GoogleMapStopsProp>([]);
const cliniciansWithLocationInfoAtom = atom<QhpWithLocationInfo[]>([]);

export const LiveMap = ({
    drawRoutes,
    stops,
    selectedClinician,
}: {
    drawRoutes: boolean;
    stops: GoogleMapStopsProp;
    selectedClinician: IClinicianOption | null;
}) => {
    const cliniciansWithLocationInfo = useLiveLocations();
    const setClinicianWithLocationInfo = useSetAtom(cliniciansWithLocationInfoAtom);
    useEffect(() => {
        setClinicianWithLocationInfo(cliniciansWithLocationInfo);
    }, [cliniciansWithLocationInfo, setClinicianWithLocationInfo]);
    const setStops = useSetAtom(stopsAtom);

    useEffect(() => {
        setStops(stops);
        if (selectedClinician) {
            setClinicianWithLocationInfo(
                cliniciansWithLocationInfo.filter(
                    (clinician) => clinician.qhp.uuid === selectedClinician.id,
                ),
            );
        } else {
            setClinicianWithLocationInfo(cliniciansWithLocationInfo);
        }
    }, [
        stops,
        cliniciansWithLocationInfo,
        setStops,
        setClinicianWithLocationInfo,
        selectedClinician,
    ]);

    return (
        <GoogleMapWithAtom
            stopsAtom={stopsAtom}
            qhpsWithLocationInfoAtom={cliniciansWithLocationInfoAtom}
            drawRoutes={drawRoutes}
            showBadgeNumbers={drawRoutes}
        />
    );
};
